var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssetSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0C17.2477 0 13.0909 1.26097 9.55523 3.62342C6.01957 5.98587 3.26384 9.34371 1.63656 13.2723C0.00927733 17.2009 -0.416443 21.5239 0.413139 25.6944C1.24272 29.865 3.29035 33.6959 6.29718 36.7028C9.30401 39.7096 13.135 41.7573 17.3056 42.5869C21.4762 43.4165 25.7991 42.9907 29.7277 41.3634C33.6563 39.7361 37.0141 36.9804 39.3766 33.4448C41.739 29.9091 43 25.7523 43 21.5C42.9936 15.7998 40.7263 10.3349 36.6957 6.3043C32.6651 2.27367 27.2002 0.00643278 21.5 0Z",
    fill: "#4CF3A8",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4851 14.4797L21.4849 28.1054M21.4849 28.1054L16.2259 22.8464M21.4849 28.1054L26.7286 22.8617",
    stroke: "#8AFFCB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetSwitchIcon);
export default __webpack_public_path__ + "static/media/AssetSwitchIcon.21e39f0fcf62d73b94fcbf344ae6e259.svg";
export { ForwardRef as ReactComponent };